export default [
  '<header class="container-fluid">',
  '  <nav class="navbar navbar-light bg-transparent border-bottom">',
  '    <div class="container-fluid">',
  '     <a class="navbar-brand" href="#">',
  '       <img src="https://res.cloudinary.com/missada/image/upload/v1645340728/Tf.js%20Playground/tfjs_playground_smaller_alt_3.png" alt="" width="30" height="30" class="d-inline-block align-text-top">',
  '       QA Playground',
  '       <span class="sub-heading">',
  '         Powered by TF.js',
  '       </span>',
  '     </a>',
  '    </div>',
  '  </nav>',
  '</header>',
  '<main>',
  '  <div class="container pt-3">',
  '    <h1>TensorFlow.js Pre-trained QnA BERT Model Playground.</h1>',
  '    <p>',
  '      The TensorFlow.js pre-trained model MobileBERT (a compressed version of BERT) takes a passage and a question as input, then returns a segment of the passage that most likely answers the question. This playground uses this model to answer questions based on the content of a given passage.',
  '    </p>',
  '    <button type="button" class="btn tp-btn-amber mb-3" id="clear">Clear Sample Passage</button>',
  '    <form id="qnaModelForm">',
  '      <div class="mb-3">',
  '        <label for="context" class="form-label"><b>Context</b></label>',
  '        <textarea class="form-control" id="context" rows="15" name="context" aria-describedby="contextHelp" placeholder="Provide the context for answering your questions..." value="" required></textarea>',
  '        <div id="contextHelp" class="form-text text-body">',
  '          Test this playground using the sample passage provided or feel free to clear it and paste your own content in the text area.',
  '          <p>The test passage is culled from Openstax. Access for free at <a href="https://openstax.org/books/us-history/pages/1-introduction"><b>https://openstax.org/books/us-history/pages/1-introduction</b></a></p>',
  '        </div>',
  '      </div>',
  '      <div class="mb-3">',
  '        <label for="question" class="form-label"><b>Question to ask</b></label>',
  '        <input type="text" class="form-control" id="question" name="question" aria-describedby="questionHelp" required />',
  '        <div id="questionHelp" class="form-text text-body">',
  '          Some suggestions based on the sample passage: \'When did the north prevail?\', \'How many soldiers died in the civil war?\', \'When did the civil war happen?\'',
  '        </div>',
  '      </div>',
  '      <div class="mb-3">',
  '        <button type="submit" class="btn tp-btn-amber" id="submit">Get Answer</button>',
  '      </div>',
  '    </form>',
  '',
  '    <div class="card mb-5">',
  '     <div class="card-body">',
  '        <div id="error"></div>',
  '        <div id="answersContainer">',
  '          <h2>Answers From the Model</h2>',
  '          <ul id="answers"></ul>',
  '        </div>',
  '      </div>',
  '    </div>',
  '  </div>',
  '</main>',
  '',
  '',
].join('\n');
